import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { ThemeProvider, createMuiTheme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import SignIn from '../scenes/SignIn';
import { PrivateRoute } from '../components/PrivateRoute';
import { useRecoilValue } from 'recoil';
import { configState } from '../features/config';
import SignUp from '../scenes/Signup';
import { Dashboard } from '../scenes/Dashboard';
import { AuthorizeEntrance } from '../scenes/Authorize';
import { SignOut } from '../scenes/SignOut';
import { UserList } from '../scenes/UserList';
import { TokenReader } from '../scenes/TokenReader';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundImage: (props: any) => props.background,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
}));

export function Main() {
	const { PRIMARY_COLOR, SIGNUP_ENABLED, PORTAL_BACKGROUND } = useRecoilValue(
		configState
	);

	const theme = createMuiTheme({
		palette: {
			primary: { main: PRIMARY_COLOR },
		},
	});
	const classes = useStyles({ background: PORTAL_BACKGROUND });
	return (
		<BrowserRouter>
			<ThemeProvider theme={theme}>
				<div className={classes.root}>
					<Switch>
						<Route path="/sign_in">
							<SignIn />
						</Route>
						{SIGNUP_ENABLED ? (
							<Route path="/sign_up">
								<SignUp />
							</Route>
						) : null}
						<Route path="/sign_out">
							<SignOut />
						</Route>
						<PrivateRoute
							path="/authorize"
							component={AuthorizeEntrance}
						/>
						<PrivateRoute path="/dashboard/:subpath?">
							<Dashboard>
								<Route path="/dashboard/app">
									<Typography>app</Typography>
								</Route>
								<Route path="/dashboard/user">
									<UserList />
								</Route>
								<Redirect to="/dashboard/user" />
							</Dashboard>
						</PrivateRoute>
						<PrivateRoute path="/token">
							<TokenReader />
						</PrivateRoute>
						<Redirect to="/dashboard" />
					</Switch>
				</div>
			</ThemeProvider>
		</BrowserRouter>
	);
}
